import React, {Component} from 'react';

const Loader = props => (
	<div className="full-width-block">
		<div className="row">
			<div className="column">
				<div className="align-content horizontal center">
					<div className="loader mg-v"></div>
				</div>
			</div>
		</div>
	</div>
);

export default Loader
